import { DefaultButton, Icon, IContextualMenuItem } from "@fluentui/react";
import { Link } from "react-router-dom";
import logo from "../../../assets/images/logo2.png";

import profileLogo from "../../../assets/images/profile2.png";
import contactLogo from "../../../assets/images/contact.png";

import orderLogo from "../../../assets/images/order.png";
import invoiceLogo from "../../../assets/images/invoice.jpg";
import paymentLogo from "../../../assets/images/payment.png";
import galleryLogo from "../../../assets/images/gallery.png";
import printLogo from "../../../assets/images/print.png";
import passwordLogo from "../../../assets/images/password.jpg";
import logoutLogo from "../../../assets/images/logout.png";

import { UserRolesModel } from '../../accounts/models/UserRolesInfo';
import { AccountService } from "../../accounts/services/AccountService";
import { BannerInfo } from '../../home/models/BannerInfo';
import { Authentication } from "./Authentication";
import { RouteUtils } from "./RouteUtils";
import { Utils } from './Utils';

type MenuProps = {
    banners: BannerInfo[];
}

export default function MenuView({ banners }: MenuProps) {
    const width6 = Utils.getColumnWidth(6);
    const userRoles: UserRolesModel = Authentication.getUserRoles();

    const isMobile = window.innerWidth <= 500;
    let height = 60;
    let iconHeight = 40;
    const logoSize = 32;

    const createMenuItems = (): IContextualMenuItem[] => {
        let items: IContextualMenuItem[] = [];

        if (Authentication.isLoggedIn()) {
            items.push({
                key: 'profiles',
                text: 'Profiles',
                iconProps: { iconName: "" },
                onClick: () => { window.open('/profiles', "_self"); },
                onRenderIcon: () => (
                    <img src={profileLogo} alt="" width={logoSize} height={logoSize} />
                )
            });

            items.push({
                key: 'contacts',
                text: 'Contacts',
                iconProps: { iconName: "" },
                onClick: () => { window.open('/contacts', "_self"); },
                onRenderIcon: () => (
                    <img src={contactLogo} alt="" width={logoSize} height={logoSize} />
                )
            });

            items.push({
                key: 'order',
                text: 'Orders',
                iconProps: { iconName: "" },
                onClick: () => { window.open('/orders', "_self"); },
                onRenderIcon: () => (
                    <img src={orderLogo} alt="" width={logoSize} height={logoSize} />
                )
            });

            items.push({
                key: 'invoice',
                text: 'Invoices',
                iconProps: { iconName: "" },
                onClick: () => { window.open('/invoices', "_self"); },
                onRenderIcon: () => (
                    <img src={invoiceLogo} alt="" width={logoSize} height={logoSize} />
                )
            });

            items.push({
                key: 'payment',
                text: 'Payments',
                iconProps: { iconName: "" },
                onClick: () => { window.open('/payments', "_self"); },
                onRenderIcon: () => (
                    <img src={paymentLogo} alt="" width={logoSize} height={logoSize} />
                )
            });

            if (userRoles.isSalesperson) {
                items.push({
                    key: 'order-admin',
                    text: 'Admin - Orders',
                    iconProps: { iconName: "" },
                    onClick: () => { window.open('/admin-orders', "_self"); },
                    onRenderIcon: () => (
                        <img src={orderLogo} alt="" width={logoSize} height={logoSize} />
                    )
                });

                items.push({
                    key: 'new-feeds',
                    text: 'Admin - New Feeds',
                    iconProps: { iconName: "" },
                    onClick: () => { window.open('/admin-new-feeds', "_self"); },
                    onRenderIcon: () => (
                        <img src={galleryLogo} alt="" width={logoSize} height={logoSize} />
                    )
                });

                items.push({
                    key: 'print-invoices',
                    text: 'Print Invoices',
                    iconProps: { iconName: "" },
                    onRenderIcon: () => (<img src={printLogo} alt="" width={logoSize} height={logoSize} />),
                    onClick: () => { window.open('/invoice-print', "_self"); }
                })
            }

            items.push({
                key: 'change-password',
                text: 'Change Password',
                iconProps: { iconName: "" },
                onClick: RouteUtils.goChangePassword,
                onRenderIcon: () => (
                    <img src={passwordLogo} alt="" width={logoSize} height={logoSize} />
                )
            });

            items.push({
                key: 'logout',
                text: 'Logout',
                iconProps: { iconName: "" },
                onClick: onLogout,
                onRenderIcon: () => (
                    <img src={logoutLogo} alt="" width={logoSize} height={logoSize} />
                )
            });
        } else {
            items.push({
                key: 'login',
                text: 'Login',
                iconProps: { iconName: "" },
                onClick: RouteUtils.goLogin,
                onRenderIcon: () => (
                    <img src={logo} alt="" width={logoSize} height={logoSize} />
                )
            });
        }

        return items;
    }

    const onLogout = () => {
        const service = new AccountService();
        service.logout();
        Authentication.clearUserAuth();
        RouteUtils.goHome();
    }

    const menuView = () => {
        return <>
            <DefaultButton
                menuProps={{
                    shouldFocusOnMount: true,
                    items: createMenuItems(),
                    calloutProps: {
                        calloutWidth: 230,
                        styles: {
                            // Makes the white panel container have curved borders
                            calloutMain: {
                                borderRadius: 10,
                                //overflow: 'hidden', // Ensures inner items respect the curve
                                padding: 10
                            },
                        },
                    }
                }}
                className="my-context-menu context-menu-text primary-color"
                styles={{
                    root: { height: 40, minWidth: 40, width: 40, border: "none" },
                    menuIcon: { display: "none !important" }
                }}
                style={{
                    backgroundColor: "transparent",
                    height: 35,
                    fontSize: "x-large",
                    paddingLeft: 5
                }}>
                <Icon iconName="NumberedListTextMirrored" />
            </DefaultButton>
        </>;
    }

    const iconDesktop = () => {
        return <div className="container cursor" onClick={RouteUtils.goHome} style={{ maxWidth: 250 }}>
            <img src={logo} alt="Bees Express" width={iconHeight} />
            <span className="brand-name pl-10">Bees Express</span>
        </div>
    }
    const iconMobile = () => {
        return <>
            <img src={logo} alt="Bees Express" onClick={RouteUtils.goHome} width={iconHeight} />
        </>;
    }

    const rightView = () => {
        if (!Utils.isNullOrEmpty(userRoles.displayName)) {
            return <div className="container font-large" style={{ height: height, display: "inline-flex" }}>
                <span className="pr-5 mb-5">
                    {userRoles.displayName}
                </span>
                <span>
                    {menuView()}
                </span>
            </div>;
        }

        return <div className="right pt-15 pr-10 mb-5 font-large">
            <span
                className="primary-color cursor"
                onClick={() => window.open("/login", "_self")}
            >Log In</span>
        </div>
    }

    return <div className="ms-Grid" style={{ background: "black" }}>
        <div className={"ms-Grid-row primary-color"}>
            <div className={width6 + " container left pl-15"} style={{ height: height }}>
                {isMobile && iconMobile()}
                {!isMobile && iconDesktop()}
            </div>

            {/*<div className={width4} style={{ height: 60, paddingTop: 15 }}>*/}
            {/*    {!Utils.isArrayNullOrEmpty(banners) && <div className="font-smaller">*/}
            {/*        {banners[0].text}*/}
            {/*    </div>}*/}
            {/*</div>*/}

            <div className={width6 + " right"} style={{ height: height, paddingRight: 3 }}>
                {rightView()}
            </div>
        </div>
    </div>;
}